import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  isCollapsed = signal(false);
  isMobileOpen = signal(false);
  isDropdownOpen = signal(false);
  isNotificationPanelOpen = signal(false);

  toggleSidebar(): void {
    if (window.innerWidth < 1024) {
      this.isMobileOpen.set(false);
      return;
    }
    this.isCollapsed.update((v) => !v);
  }

  toggleMobileSidebar(): void {
    this.isMobileOpen.update((v) => !v);
  }

  toggleDropdown(): void {
    this.isDropdownOpen.update((v) => !v);
  }

  closeDropdown(): void {
    this.isDropdownOpen.set(false);
  }

  toggleNotificationPanel(): void {
    this.isNotificationPanelOpen.update((v) => !v);
  }

  closeNotificationPanel(): void {
    this.isNotificationPanelOpen.set(false);
  }
}
